import Model, { attr } from '@ember-data/model';
import { service } from '@ember/service';
import { NotificationLogLevels } from 'eflex/constants/notification-log';
import { tracked } from '@glimmer/tracking';
import { objectAttr, arrayAttr } from 'eflex/decorators';
import { getCaptionText } from 'eflex/util/translation-helper';
import { isPresent } from '@ember/utils';

export default class Log extends Model {
  @attr('date', { defaultValue() { return new Date(); } }) timestamp;
  @attr('string') source;
  @attr('boolean', { defaultValue: true }) isActive;
  @attr('boolean', { defaultValue: false }) pendingDeploy;
  @attr('string') level;
  @attr('string') captionId;
  @attr('string') plainMessage;
  @arrayAttr formattedStrings;
  @objectAttr createdBy;
  @objectAttr location;

  @tracked isSelected = false;

  @service intl;
  @service userRepo;
  @service currentUser;

  get message() {
    if (this.plainMessage != null) {
      return this.plainMessage;
    } else if (this.captionId) {
      return this.#translate({
        captionId: this.captionId,
        formattedStrings: this.formattedStrings,
        location: this.location,
      });
    } else {
      return null;
    }
  }

  get levelIcon() {
    switch (this.level) {
      case NotificationLogLevels.ALARM: {
        return 'circle-exclamation';
      }
      case NotificationLogLevels.ERROR: {
        return 'exclamation';
      }
      case NotificationLogLevels.WARN: {
        return 'triangle-exclamation';
      }
      default: {
        return null;
      }
    }
  }

  acknowledge() {
    this.isActive = false;
  }

  #translate({ captionId, formattedStrings, location }) {
    const stringObject = {};
    formattedStrings?.forEach((str, i) => {
      stringObject[`${i}`] = str;
    });

    const locationCaptions = location?.captions;

    if (isPresent(locationCaptions)) {
      const locationName = getCaptionText(location?.captions, this.currentUser);
      stringObject.treeItem = locationName;
    }

    return this.intl.t(captionId, stringObject);
  }
}
